import * as React from 'react';
import { Box, Text } from '@chakra-ui/react';

// Versión genérica CustomList: pinta exactamente la misma lista sin atarse a un DTO concreto. El componente no sabe nada del tipo de
// los elementos, así que quien lo usa le dice cómo obtener la clave de cada uno (itemKey) y qué texto pintar (itemText).
type CustomListProps<T> = {
	items: T[];
	onSelectItem: (item: T) => void;
	// Identificador único del elemento. Es lo que se compara con selectedItemKey para saber qué fila está seleccionada.
	itemKey: (item: T) => React.Key;
	// Contenido que se pinta dentro de la fila.
	itemText: (item: T) => React.ReactNode;
	// Clave del elemento seleccionado. Si no se pasa, la lista no marca ninguna fila como seleccionada.
	selectedItemKey?: React.Key;
}

export function CustomList<T>(props: CustomListProps<T>) {
	const { items, onSelectItem, itemKey, itemText, selectedItemKey } = props;

	const listItems = items.map((s, idx) => {

		const key = itemKey(s);
		const isEven = idx % 2 === 0;
		const isLineSelected = selectedItemKey !== undefined && selectedItemKey === key;
		const isLast = idx === items.length - 1;

		return <Box as='li'
			key={key}
			w={'full'}
			minH={'10'}
			display={'flex'}
			flexDirection={'column'}
			justifyContent={'center'}
			alignItems={'center'}
			paddingY={'3'}
			px={'3'}
			lineHeight={'1.25'}
			bg={
				isLineSelected
					? { base: 'blue.100', _dark: 'blue.600' }
					: isEven
						? { base: 'neutral.50', _dark: 'neutral.700' }
						: { base: 'white', _dark: 'neutral.800' }
			}
			borderTopWidth={isEven ? '1px' : '0'}
			borderBottomWidth={isEven || isLast ? '1px' : '0'}
			borderColor={
				isLineSelected
					? { base: 'blue.100', _dark: 'blue.600' }
					: isEven || isLast
						? { base: 'neutral.100', _dark: 'neutral.100' }
						: { base: 'white', _dark: 'neutral.800' }
			}
			_hover={{
				bg: { base: 'blue.50', _dark: 'blue.500' },
				'@media (hover: none)': { bg: 'unset' }
			}}
			cursor={'pointer'}
			onClick={() => onSelectItem(s)}
			transitionProperty='filter, transform'
			transitionDuration='0.05s'
			_active={{
				transform: 'scale(0.97)'
			}}
		>
			<Text>{itemText(s)}</Text>
		</Box>;
	});

	return <Box as='ul' fontSize={'sm'} width={'full'}>
		{listItems}
	</Box>;
}
